import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { FileText, Download, Car, Home as HomeIcon, Building2, ArrowRight } from "lucide-react";
import { formsData } from "../mock";

const iconMap = { Car, Home: HomeIcon, Building2 };

const Forms = () => {
  useEffect(() => {
    window.scrollTo({ top: 0 });
  }, []);

  return (
    <div className="relative">
      <section className="relative overflow-hidden">
        <div className="aurora bg-[#8ec4ec] h-80 w-80 -top-20 -left-16" />
        <div className="aurora bg-[#8ec4ec] h-80 w-80 top-0 right-0" />
        <div className="max-w-4xl mx-auto px-6 pt-16 pb-8 text-center relative z-10 fade-up">
          <div className="h-16 w-16 mx-auto rounded-2xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white mb-6 shadow-lg">
            <FileText size={30} />
          </div>
          <nav className="text-sm text-slate-500 mb-4 flex items-center justify-center gap-2">
            <Link to="/" className="hover:text-[#0066b3]">Home</Link>
            <span>/</span>
            <span className="text-[#0066b3] font-medium">Forms</span>
          </nav>
          <h1 className="font-display text-4xl md:text-5xl font-extrabold text-[#0a2b52]">
            Download <span className="brand-gradient-text">Forms</span>
          </h1>
          <p className="mt-5 text-lg text-slate-600 max-w-2xl mx-auto">
            Access and download the insurance forms you need. Click any form to
            open the PDF in a new tab.
          </p>
        </div>
      </section>

      <section className="max-w-5xl mx-auto px-6 pt-6 space-y-10">
        {formsData.map((group, gi) => {
          const Icon = iconMap[group.icon] || FileText;
          return (
            <div
              key={group.category}
              className="fade-up"
              style={{ animationDelay: `${gi * 0.06}s` }}
            >
              <div className="flex items-center gap-3 mb-5">
                <div className="h-11 w-11 rounded-xl bg-gradient-to-br from-[#0066b3] to-[#003c7a] flex items-center justify-center text-white">
                  <Icon size={22} />
                </div>
                <h2 className="font-display text-2xl font-bold text-[#0a2b52]">
                  {group.category}
                </h2>
              </div>
              <div className="grid sm:grid-cols-2 gap-4">
                {group.forms.map((f) => (
                  <a
                    key={f.name}
                    href={f.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group glass rounded-2xl p-5 flex items-center justify-between gap-4 card-hover"
                  >
                    <span className="flex items-center gap-3">
                      <span className="h-10 w-10 rounded-lg bg-[#0066b3]/10 flex items-center justify-center text-[#0066b3]">
                        <FileText size={20} />
                      </span>
                      <span className="font-medium text-[#0a2b52] leading-snug">
                        {f.name}
                      </span>
                    </span>
                    <Download
                      size={20}
                      className="text-slate-400 group-hover:text-[#0066b3] transition-colors shrink-0"
                    />
                  </a>
                ))}
              </div>
            </div>
          );
        })}
      </section>

      <section className="max-w-7xl mx-auto px-6 pt-14">
        <div className="glass-strong rounded-3xl p-10 md:p-12 text-center relative overflow-hidden">
          <div className="aurora bg-[#cfe4f6] h-64 w-64 -bottom-24 -right-10" />
          <h2 className="font-display text-3xl font-extrabold text-[#0a2b52] relative">
            Can't find the form you need?
          </h2>
          <p className="text-slate-600 mt-3 max-w-xl mx-auto relative">
            Contact our office and our friendly team will send you the right
            form right away.
          </p>
          <Link
            to="/contact"
            className="brand-btn inline-flex items-center gap-2 px-7 py-3.5 rounded-full font-semibold mt-7 relative"
          >
            Contact Us <ArrowRight size={18} />
          </Link>
        </div>
      </section>
    </div>
  );
};

export default Forms;
